<template>
  <div class="row" style="text-align: left!important;">
    <div v-if="cellData" class="col-md-auto subelement">
       <div>{{ getResult(cellData) }}</div>
    </div>
    <div v-if="cellData" class="col-md-auto subelement">
       <div>{{ getNumberOfShops(cellData) }}</div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    cellData: {
      type: Object,
      default: () => {}
    }
  },
  
  created() {
    // console.log('WaveOverviewCell - created - data: ' + JSON.stringify(this.cellData));
  },

  methods: {
    getResult(item) {

        if (!item.SurveyWave[item.CurrentColIndex] && item.KpiFehlartikel) {
            return '';
        }

        let val = item.SurveyWave[item.CurrentColIndex] ? item.SurveyWave[item.CurrentColIndex].Result + '%' : 'N/A';
        return val ? val : 'N/A';
    },

    getNumberOfShops(item) {
        
        if (!item.SurveyWave[item.CurrentColIndex] && item.KpiFehlartikel) {
            return 'n = ' + item.KpiFehlartikelAnzahl;
        }

        let val = item.SurveyWave[item.CurrentColIndex] ? 'n = ' + item.SurveyWave[item.CurrentColIndex].NumberOfShopsTotal : 'N/A';
        return val ? val : 'N/A';
    }
  }
};
</script>
<style scoped>

.subelement {
    min-width: 60px;
}

.rescell{
  width: 100%;
  height: 2rem;
}

.rescelllw, .rescellaw, .rescellnow {
  height: 1rem;
}

.rescellnow {
  width: 0%;
}

</style>
